var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.167 12.8334H6.16699V11.1667H11.167V6.16675H12.8337V11.1667H17.8337V12.8334H12.8337V17.8334H11.167V12.8334Z",
    fill: "#40444D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/newChatIcon.bd0b1b3b8898696f4a4b99254952dd5a.svg";
export { ForwardRef as ReactComponent };